import { useEffect, useState } from 'react';
import { getYaraRules } from 'api/api_service';
import strings from '../../strings/strings.json'
import YaraList from './yara_list';
import ChooseYaraModal from './choose_yara_modal';


export default function Yara() {
    const [yaraData, setYaraData] = useState<Array<string>>([]);
    const [open, setOpen] = useState(false)

    useEffect(() => {
        getYaraList()
    }, [])

    const getYaraList = () => {
        getYaraRules()
            .then(res => {
                if (res.status === 200)
                    setYaraData(res.data.data)
            })
    }

    return (
        <div className='w-full'>
            <div>
                <div className='mt-10 mx-10 flex justify-between items-center'>
                    <span className='primary_text_color font-bold text-lg'>{strings.yara_edit}</span>
                    <button className='rounded-full border border-black px-10 py-2 primary_bg_color text-white' onClick={() => setOpen(true)}>{strings.public_chooseFile}</button>
                </div>
                <div dir="ltr" className='h-96 overflow-y-scroll border border-gray-200 rounded-lg m-5'>
                    <YaraList
                        yaraData={yaraData}
                        refreshList={() => getYaraList()}
                    />
                </div>
            </div>

            <ChooseYaraModal
                confirmClicked={() => getYaraList()}
                onCloseModal={() => setOpen(false)}
                openModal={open}
            />
        </div>
    )
}